export default __webpack_public_path__ + "static/media/up_arrow.21a3c065.svg";